import { useFormikContext } from "formik";
import { Dispatch, useEffect } from "react";

export const GiveValuestoFormComponent = ({
  setformValues,
}: {
  setformValues: Dispatch<React.SetStateAction<any>>;
}) => {
  // Grab values and submitForm from context
  const { values, submitForm } = useFormikContext();
  useEffect(() => {
    setformValues(values);
  }, [values, submitForm]);
  return null;
};
